var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseNotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#EFF5F5",
    fillOpacity: 0.9,
    stroke: "#EFF5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60237 15.3972C8.77427 15.5691 9.00739 15.6656 9.25046 15.6656C9.49352 15.6656 9.72664 15.5691 9.89854 15.3972L12.0005 13.2953L14.1024 15.3972C14.2753 15.5642 14.5068 15.6566 14.7472 15.6545C14.9875 15.6524 15.2174 15.556 15.3874 15.3861C15.5573 15.2161 15.6537 14.9862 15.6558 14.7459C15.6579 14.5055 15.5655 14.274 15.3985 14.1011L13.2966 11.9992L15.3985 9.89724C15.5655 9.72435 15.6579 9.4928 15.6558 9.25245C15.6537 9.0121 15.5573 8.78219 15.3874 8.61224C15.2174 8.44228 14.9875 8.34587 14.7472 8.34378C14.5068 8.3417 14.2753 8.43409 14.1024 8.60107L12.0005 10.703L9.89854 8.60107C9.72565 8.43409 9.4941 8.3417 9.25375 8.34378C9.01341 8.34587 8.7835 8.44228 8.61354 8.61224C8.44358 8.78219 8.34718 9.0121 8.34509 9.25245C8.343 9.4928 8.43539 9.72435 8.60237 9.89724L10.7043 11.9992L8.60237 14.1011C8.43052 14.273 8.33398 14.5061 8.33398 14.7492C8.33398 14.9922 8.43052 15.2253 8.60237 15.3972Z",
    fill: "#99A4A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNotify);
export default __webpack_public_path__ + "static/media/closeNotify.be668c743c70eda4e01183c39cd0a0d5.svg";
export { ForwardRef as ReactComponent };